import { useSelector } from 'react-redux'
import { openModalSectionSelector } from '../selectors'

export const useOpenModalOpenSection = () => {
  return useSelector(openModalSectionSelector)
}
